<template>
  <div class="app-container" v-if="detail">
    <el-card>
      <div class="back-box"><div @click="goBack"><img src="../../../assets/back.png" /><span>返回</span></div></div>

      <div class="tab-box">
        <span :class="{'active': tabType == 1}" @click="tabType = 1">基础信息</span>
        <span :class="{'active': tabType == 2}" @click="tabType = 2">物流信息</span>
        <span :class="{'active': tabType == 3}" @click="tabType = 3">订单详情</span>
        <span :class="{'active': tabType == 4}" @click="tabType = 4">操作记录</span>
      </div>

      <!-- 基础信息 -->
      <template v-if="tabType == 1">
        <div class="title-box"><span class="txt1">订单信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="订单编号">{{ detail.orderNum }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">{{ statusLabel(detail.state) }}</el-descriptions-item>
          <el-descriptions-item label="订单类型">{{ detail.orderType==2?'售后退返':(detail.orderType==3?'其他':'内购') }}</el-descriptions-item>
          <el-descriptions-item label="随货同行单">{{ detail.customerIdcard || '-' }}</el-descriptions-item>
          <el-descriptions-item label="下单时间">{{ formatTime(detail.createdTime) }}</el-descriptions-item>
          <el-descriptions-item label="付款时间">{{ formatTime(detail.payTime) }}</el-descriptions-item>
          <el-descriptions-item label="快递方式">{{ detail.expressName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="创建人">{{ detail.createdBy }}</el-descriptions-item>
          <el-descriptions-item label="订单备注">{{ detail.orderRemark || '-' }}</el-descriptions-item>
        </el-descriptions>

        <div class="title-box"><span class="txt1">客户信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="客户姓名">{{ detail.customerName }}</el-descriptions-item>
          <el-descriptions-item label="客户电话">{{ detail.customerPhone }}</el-descriptions-item>
        </el-descriptions>

        <!-- 客户从属关系 -->
        <div class="title-box"><span class="txt1">客户从属关系</span></div>
        <el-descriptions :column="1">
          <el-descriptions-item v-if="detail.techThreeName || detail.techTwoName || detail.techOneName" label="技术线">
            <div class="fr1-body">
              <span class="blueColor">{{custTechLine}}</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="业务线">
            <div class="fr1-body">
              <span class="blueColor">{{custBusinessLine}}</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item v-if="detail.cityName" label="城市公司">{{ detail.cityName }}</el-descriptions-item>
        </el-descriptions>

        <div class="title-box"><span class="txt1">支付信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="原价总额">￥{{ detail.originalPrice || detail.payTotalMoney }}</el-descriptions-item>
          <el-descriptions-item label="折扣立减金额">￥{{ detail.discountAmount || 0 }}</el-descriptions-item>
          <el-descriptions-item label="商品金额(折后)">￥{{ detail.payTotalMoney }}</el-descriptions-item>
          <el-descriptions-item label="运费">￥{{ detail.freight || 0 }}</el-descriptions-item>
          <el-descriptions-item label="实付金额"><b class="redColor">￥{{ detail.allPayMoney }}</b></el-descriptions-item>
          <el-descriptions-item v-if="detail.payTime" label="支付时间">{{ formatTime(detail.payTime) }}</el-descriptions-item>
        </el-descriptions>
        <div class="title-box" style="margin-top:10px"><span class="txt1">支付方式</span></div>
        <el-table :data="detail.payTypeList || []" style="width: 300px">
          <el-table-column prop="name" label="支付方式" align="center" />
          <el-table-column prop="money" label="支付金额" align="center" />
        </el-table>

        <div class="title-box"><span class="txt1">审核信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="审核结果">
            <el-tag v-if="detail.reviewState===1" type="success" size="small">已同意</el-tag>
            <el-tag v-else-if="detail.reviewState===2" type="danger" size="small">已驳回</el-tag>
            <span v-else>-</span>
          </el-descriptions-item>
          <el-descriptions-item label="审核人">{{ detail.reviewBy || '-' }}</el-descriptions-item>
          <el-descriptions-item label="审核时间">{{ formatTime(detail.reviewTime) }}</el-descriptions-item>
          <el-descriptions-item label="审核备注">{{ detail.reviewRemark || '-' }}</el-descriptions-item>
        </el-descriptions>

        <!-- 审核操作按钮(仅待审核状态显示) -->
        <div v-if="detail.state===2 && showAuditBtns" style="margin-top:15px">
          <el-button type="success" size="small" @click="doApprove">审核通过</el-button>
          <el-button type="danger" size="small" @click="doReject">审核驳回</el-button>
        </div>
      </template>

      <!-- 物流信息 -->
      <template v-if="tabType == 2">
        <div class="title-box"><span class="txt1">收货信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="收货人">{{ detail.addrName || detail.customerName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{ detail.addrPhone || detail.customerPhone || '-' }}</el-descriptions-item>
          <el-descriptions-item label="收货地址">{{ (detail.addrProvince||'')+(detail.addrCity||'')+(detail.addrDistrict||'')+(detail.addrDetail||'') || '-' }}</el-descriptions-item>
        </el-descriptions>

        <div class="title-box"><span class="txt1">物流信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="快递方式">{{ detail.expressName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="发货时间">{{ formatTime(detail.sendTime) }}</el-descriptions-item>
          <el-descriptions-item label="完成时间">{{ formatTime(detail.finishTime) }}</el-descriptions-item>
        </el-descriptions>

        <!-- 多包裹物流单号 -->
        <div class="title-box" style="margin-top:10px"><span class="txt1">快递单号</span></div>
        <el-table v-if="detail.deliveryList && detail.deliveryList.length > 0" :data="detail.deliveryList" style="width: 100%">
          <el-table-column type="index" label="包裹" align="center" width="60" />
          <el-table-column prop="expressName" label="快递公司" align="center" width="120" />
          <el-table-column label="快递单号" align="center">
            <template slot-scope="{row}">
              <el-link type="primary" @click="lookLogistics(row)">{{ row.logisticsNumber }}</el-link>
            </template>
          </el-table-column>
        </el-table>
        <el-descriptions v-else>
          <el-descriptions-item label="快递单号">
            <el-link v-if="detail.logisticsNumber" type="primary" @click="lookLogistics({logisticsNumber: detail.logisticsNumber})">{{ detail.logisticsNumber }}</el-link>
            <span v-else>-</span>
          </el-descriptions-item>
        </el-descriptions>

        <div class="title-box"><span class="txt1">JST推送</span></div>
        <el-descriptions>
          <el-descriptions-item label="推送状态">{{ detail.isSendedJst==1?'已推送':'未推送' }}</el-descriptions-item>
          <el-descriptions-item label="聚水潭单号">{{ detail.jstSoId || '-' }}</el-descriptions-item>
        </el-descriptions>
      </template>

      <!-- 订单详情 -->
      <template v-if="tabType == 3">
        <div class="title-box"><span class="txt1">基础信息</span></div>
        <el-descriptions>
          <el-descriptions-item label="订单编号">{{ detail.orderNum }}</el-descriptions-item>
          <el-descriptions-item label="订单状态">{{ statusLabel(detail.state) }}</el-descriptions-item>
          <el-descriptions-item label="随货同行单">{{ detail.customerIdcard || '-' }}</el-descriptions-item>
          <el-descriptions-item label="客户姓名">{{ detail.customerName }}</el-descriptions-item>
          <el-descriptions-item label="客户电话">{{ detail.customerPhone }}</el-descriptions-item>
          <el-descriptions-item label="收货地址">{{ (detail.addrProvince||'')+(detail.addrCity||'')+(detail.addrDistrict||'')+(detail.addrDetail||'') || '-' }}</el-descriptions-item>
        </el-descriptions>

        <div class="title-box"><span class="txt1">商品列表</span></div>
        <el-table :data="detail.goodsList" style="width: 100%">
          <el-table-column type="index" label="序号" width="50" align="center" />
          <el-table-column prop="goodsName" label="商品名称" align="center" min-width="150" />
          <el-table-column prop="spec" label="规格" align="center" width="100" />
          <el-table-column prop="skuCode" label="聚水潭编码" align="center" width="140" />
          <el-table-column prop="retailPrice" label="零售价" align="center" width="100">
            <template slot-scope="{row}">￥{{ row.retailPrice || row.goodsPrice }}</template>
          </el-table-column>
          <el-table-column prop="goodsPrice" label="实际单价" align="center" width="100">
            <template slot-scope="{row}">￥{{ row.goodsPrice }}</template>
          </el-table-column>
          <el-table-column prop="goodsQuantity" label="数量" align="center" width="80" />
          <el-table-column label="小计" align="center" width="100">
            <template slot-scope="{row}">￥{{ row.goodsSubtotal }}</template>
          </el-table-column>
        </el-table>
        <el-descriptions class="mt10">
          <el-descriptions-item label="原价总额">￥{{ detail.originalPrice || detail.payTotalMoney }}</el-descriptions-item>
          <el-descriptions-item label="折扣立减金额">￥{{ detail.discountAmount || 0 }}</el-descriptions-item>
          <el-descriptions-item label="商品金额(折后)">￥{{ detail.payTotalMoney }}</el-descriptions-item>
          <el-descriptions-item label="运费">￥{{ detail.freight || 0 }}</el-descriptions-item>
          <el-descriptions-item label="实付金额"><b class="redColor">￥{{ detail.allPayMoney }}</b></el-descriptions-item>
        </el-descriptions>

        <!-- 支付方式 -->
        <div class="title-box" style="margin-top:10px"><span class="txt1">支付方式</span></div>
        <el-table :data="detail.payTypeList || []" style="width: 300px">
          <el-table-column prop="name" label="支付方式" align="center" />
          <el-table-column prop="money" label="支付金额" align="center" />
        </el-table>
      </template>

      <!-- 操作记录 -->
      <template v-if="tabType == 4">
        <el-table :data="logList" v-loading="logLoading" fit>
          <el-table-column label="操作时间" width="160">
            <template slot-scope="{row}">{{ formatTime(row.createdTime) }}</template>
          </el-table-column>
          <el-table-column prop="createdBy" label="操作人" width="100" />
          <el-table-column prop="title" label="操作内容" min-width="150" />
          <el-table-column prop="remarks" label="备注" min-width="200" />
        </el-table>
        <pagination v-show="logTotal>0" :total="logTotal" :pageNo.sync="logQuery.page" :pageSize.sync="logQuery.pageSize" @pagination="getLogList" />
      </template>
    </el-card>
    <logistics-details-vue ref="logisticsDetailsVue" />
    <outbound-order-add ref="addDialog" :visible.sync="addVisible" @success="fetchDetail(detail.id)" />
  </div>
</template>

<script>
import { getOrderDetail } from '@/api/order/outboundOrder'
import request from '@/utils/request'
import sysStepLogApi from '@/api/log/sysStepLog'
import Pagination from '@/components/Pagination'
import logisticsDetailsVue from '@/views/common/logisticsDetails.vue'
import OutboundOrderAdd from './add.vue'
export default {
  name: 'OutboundOrderShow',
  components: { Pagination, logisticsDetailsVue, OutboundOrderAdd },
  props: { rowItem: { type: Object, default: null }, showAuditBtns: { type: Boolean, default: false } },
  data() { return {
    detail: null, tabType: 1, addVisible: false,
    logList: [], logTotal: 0, logLoading: false,
    logQuery: { type: 9, page: 1, pageSize: 10 }
  }},
  watch: {
    rowItem: {
      immediate: true,
      handler(val) {
        if (val && val.id) { this.fetchDetail(val.id); this.getLogList() }
      }
    }
  },
  computed: {
    custBusinessLine() {
      const d = this.detail
      const arr = []
      if (d.custOneName) arr.push(d.custOneName + '【营销总监】')
      if (d.custTwoName) arr.push(d.custTwoName + '【营销经理】')
      if (d.custThreeName) arr.push(d.custThreeName + '【大区经理】')
      if (d.custFourName) arr.push(d.custFourName + '【地区经理】')
      if (d.custFiveName) arr.push(d.custFiveName + '【县区经理】')
      const self = d.customerName + '【' + this.getCLevelLabel(d.custCLevel) + '】'
      return arr.length ? self + ' - ' + arr.reverse().join(' - ') : self
    },
    custTechLine() {
      const d = this.detail
      const arr = []
      if (d.techOneName) arr.push(d.techOneName + '【技术总监】')
      if (d.techTwoName) arr.push(d.techTwoName + '【技术经理】')
      if (d.techThreeName) arr.push(d.techThreeName + '【技术老师】')
      const self = d.customerName + '【' + this.getCLevelLabel(d.custCLevel) + '】'
      return arr.length ? self + ' - ' + arr.reverse().join(' - ') : self
    },
  },
  methods: {
    getCLevelLabel(cLevel, customerType) {
      const map = { 1: '总监', 2: '营销经理', 3: '大区经理', 4: '地区经理', 5: '县区经理', 6: '研修班', 7: '体验班', 8: '普通人员' }
      if (cLevel && map[cLevel]) return map[cLevel]
      const tMap = { 1: '总监经理', 2: '业务员', 3: '加盟商' }
      return tMap[customerType] || ''
    },
    fetchDetail(id) {
      getOrderDetail(id).then(r => {
        if (r.code=='0') { this.detail = r.data }
      })
    },
    getLogList() {
      if (!this.rowItem || !this.rowItem.id) return
      this.logLoading = true
      sysStepLogApi.fetchList({ ...this.logQuery, foreignId: this.rowItem.id }).then(({ data }) => {
        this.logList = data.list || []; this.logTotal = data.total || 0
      }).finally(() => { this.logLoading = false })
    },
    formatTime(v) { if (!v) return '-'; return v.replace('T',' ') },
    goBack() { this.$emit('handleShow', null, 1) },
    statusLabel(s) { const m={0:'已取消',1:'待支付',2:'待审核',3:'待发货',4:'待收货',5:'审核不通过',6:'已完成'}; return m[s]||s },
    lookLogistics(row) {
      if (!row.logisticsNumber) return
      const pho = this.detail.customerPhone || ''
      const str = pho ? `:${pho.trim().slice(-4)}` : ''
      try {
        this.$refs.logisticsDetailsVue.handleShow(row.logisticsNumber + str)
      } catch(e) {}
    },
    doApprove() {
      this.$confirm('确认同意该出库订单？同意后将推送JST。', '审核通过', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
        request({ url: '/outbound/order/review/approve/' + this.detail.id, method: 'post' }).then(res => {
          if (res.code === '0') { this.$message.success('已同意'); this.fetchDetail(this.detail.id); this.$emit('refreshAudit') }
        })
      }).catch(() => {})
    },
    doReject() {
      this.$prompt('请输入驳回原因', '驳回申请', { confirmButtonText: '确定', cancelButtonText: '取消', inputPattern: /\S/, inputErrorMessage: '驳回原因不能为空' }).then(({ value }) => {
        request({ url: '/outbound/order/review/reject/' + this.detail.id, method: 'post', params: { remark: value } }).then(res => {
          if (res.code === '0') { this.$message.success('已驳回'); this.fetchDetail(this.detail.id); this.$emit('refreshAudit') }
        })
      }).catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
}
.blueColor {
  color: #1596cd;
}
.redColor {
  color: #e73f3f !important;
}
.fr1-body {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.mt10 {
  margin-top: 10px;
}
</style>
